function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState, useRef, useEffect } from 'react';
import { Accordion, AccordionItem, Flex, InfoIcon, Table, Tbody, Tr, Td, chakra as C } from '@tapresearch/ui/components';
import ReactTooltip from 'Shared/Tooltip';
import useAsset from '../../hook/useAsset';
import Modal from 'Shared/Modal';
import * as S from './BarChart.styled';
export default /*#__PURE__*/ React.memo(function(param) {
    var isCrossTab = param.isCrossTab, data = param.data, id = param.id, mode = param.mode, crossTabQuestion = param.crossTabQuestion, isRating = param.isRating;
    var _useState = _sliced_to_array(useState(null), 2), isOpenFullAnswerImageURL = _useState[0], setIsOpenFullAnswerImageURL = _useState[1];
    var asset = useAsset();
    var _useState1 = _sliced_to_array(useState(), 2), graphData = _useState1[0], setGraphData = _useState1[1];
    var toolTipId = useRef("toolTipId-".concat(id));
    var _useState2 = _sliced_to_array(useState(undefined), 2), rankFilter = _useState2[0], setRankFilter = _useState2[1];
    var isCTRanking = crossTabQuestion && crossTabQuestion.answer_type === asset.constants.TAP_ANSWER_TYPE_RANKING;
    var processRankingData = function(sets) {
        var total = 0;
        var datasets = sets.map(function(question) {
            var qCount = 0;
            var newVals = question.values.map(function(param) {
                var id = param.id, label = param.label, primary_ranks = param.primary_ranks;
                var aCount = primary_ranks.reduce(function(a, b, i) {
                    return rankFilter >= i ? a + b : a;
                }, 0);
                qCount += aCount;
                return {
                    id: id,
                    label: label,
                    total: aCount,
                    primary_ranks: primary_ranks
                };
            });
            total += qCount;
            return _object_spread_props(_object_spread({}, question), {
                total: qCount,
                values: newVals
            });
        });
        return {
            datasets: datasets,
            total: total
        };
    };
    useEffect(function() {
        if (isCrossTab) {
            var _ref = (isCTRanking ? processRankingData(data.datasets) : data) || [], datasets = _ref.datasets, total = _ref.total;
            setGraphData({
                legends: datasets[0] ? datasets[0].values.reduce(function(acc, elem) {
                    return _object_spread_props(_object_spread({}, acc), _define_property({}, elem.label, true));
                }, {}) : [],
                secondaryAnswers: data.secondaryAnswers,
                datasets: datasets,
                total: total
            });
        } else {
            setGraphData(data);
        }
    }, [
        data,
        isCTRanking,
        rankFilter,
        isCrossTab,
        mode
    ]);
    useEffect(function() {
        setRankFilter(isCTRanking ? 0 : undefined);
    }, [
        isCTRanking
    ]);
    useEffect(function() {
        ReactTooltip.rebuild();
    }, [
        graphData
    ]);
    var onChangeLegendsFilter = function(field) {
        var newLegends = _object_spread_props(_object_spread({}, graphData.legends), _define_property({}, field, !graphData.legends[field]));
        setGraphData(_object_spread_props(_object_spread({}, graphData), {
            legends: newLegends
        }));
    };
    var onChangeRanksFilter = function(field) {
        setRankFilter(field);
    };
    if (!graphData || isCrossTab && !graphData.legends) {
        return null;
    }
    // Find row that is longest in term of width
    var highestTotal = isCrossTab ? graphData.datasets.reduce(function(curr, elem) {
        return elem.total > curr ? elem.total : curr;
    }, 0) : graphData.datasets.reduce(function(curr, elem) {
        return elem.total > curr ? elem.total : curr;
    }, 0);
    return /*#__PURE__*/ React.createElement("div", null, isCrossTab ? /*#__PURE__*/ React.createElement("div", null, graphData.datasets.map(function(dataset, idx) {
        return /*#__PURE__*/ React.createElement(ChartRow, {
            rowIndex: idx,
            key: idx,
            dataset: dataset,
            legends: graphData.legends,
            isCrossTab: true,
            toolTipId: toolTipId.current,
            mode: mode,
            total: graphData.total,
            highestTotal: highestTotal,
            isRating: isRating
        });
    }), /*#__PURE__*/ React.createElement(S.LegendContainer, null, isCTRanking && /*#__PURE__*/ React.createElement(S.LegendItem, null, /*#__PURE__*/ React.createElement(S.RankHelpTooltip, {
        place: "bottom",
        type: "dark",
        effect: "solid"
    }), /*#__PURE__*/ React.createElement(S.TabSelect, {
        onChange: function(e) {
            return onChangeRanksFilter(e.target.value);
        },
        value: graphData.rankFilter
    }, data.datasets.map(function(_, i) {
        return /*#__PURE__*/ React.createElement("option", {
            value: i,
            key: i
        }, i === 0 ? "#".concat(i + 1, " Ranked answers only") : "#1 to #".concat(i + 1, " Ranked answers"));
    })), /*#__PURE__*/ React.createElement("span", {
        "data-tip": 'Range of ranked responses included from: "'.concat(crossTabQuestion.name, '".')
    }, /*#__PURE__*/ React.createElement(InfoIcon, null))), graphData.datasets && graphData.datasets[0] && graphData.datasets[0].values.map(function(value, idx) {
        return /*#__PURE__*/ React.createElement(S.LegendItem, {
            key: idx
        }, graphData.secondaryAnswers[idx].image && graphData.secondaryAnswers[idx].image.thumbnail && /*#__PURE__*/ React.createElement(S.RowThumbImage, {
            onClick: function() {
                return setIsOpenFullAnswerImageURL(graphData.secondaryAnswers[idx].image.full);
            },
            src: graphData.secondaryAnswers[idx].image.thumbnail
        }), /*#__PURE__*/ React.createElement(S.Legend, {
            onClick: function() {
                return onChangeLegendsFilter(value.label);
            },
            background: S.getBarLabelColor(idx)
        }, /*#__PURE__*/ React.createElement(S.LegendIcon, {
            src: graphData.legends[value.label] ? asset.check_square_icon : asset.square_regular_icon
        }), value.label));
    })), /*#__PURE__*/ React.createElement(S.Tooltip, {
        id: toolTipId.current,
        place: "top",
        type: "dark",
        getContent: function(dataTip) {
            if (graphData.datasets[dataTip]) {
                return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", null, graphData.datasets[dataTip].label), isRating && /*#__PURE__*/ React.createElement("p", null, "Average Rating:", ' ', parseFloat(graphData.datasets[dataTip].values.reduce(function(acc, ans, i) {
                    return (i + 1) * ans.total + acc;
                }, 0) / graphData.datasets[dataTip].total).toFixed(2)), graphData.datasets[dataTip].values.map(function(value, idx) {
                    if (graphData.legends[value.label]) {
                        var percentage = parseFloat((value.total / graphData.datasets[dataTip].total || 0) * 100).toFixed(2);
                        return /*#__PURE__*/ React.createElement("div", {
                            key: idx
                        }, value.label, ": ", percentage, "% (", value.total, ")");
                    }
                }));
            }
        }
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, isRating && /*#__PURE__*/ React.createElement(Flex, S.AverageRatingStyles, "Average:", ' ', parseFloat(graphData.datasets.reduce(function(acc, ans, i) {
        return (i + 1) * ans.total + acc;
    }, 0) / graphData.total).toFixed(2)), graphData.datasets.map(function(dataset, idx) {
        return /*#__PURE__*/ React.createElement(ChartRow, {
            total: graphData.total,
            dataset: dataset,
            key: idx,
            highestTotal: highestTotal,
            onViewFullImage: function() {
                return setIsOpenFullAnswerImageURL(dataset.image.full);
            }
        });
    })), isOpenFullAnswerImageURL && /*#__PURE__*/ React.createElement(Modal, {
        maxWidth: 800,
        isOpen: true,
        onClose: function() {
            return setIsOpenFullAnswerImageURL(null);
        }
    }, isOpenFullAnswerImageURL));
});
var ChartRow = /*#__PURE__*/ React.memo(function(param) {
    var dataset = param.dataset, total = param.total, isCrossTab = param.isCrossTab, rowIndex = param.rowIndex, legends = param.legends, toolTipId = param.toolTipId, onViewFullImage = param.onViewFullImage, mode = param.mode, highestTotal = param.highestTotal;
    var asset = useAsset();
    var labelRef = useRef();
    var _useState = _sliced_to_array(useState(0), 2), height = _useState[0], setHeight = _useState[1];
    useEffect(function() {
        if (labelRef.current) {
            setHeight(labelRef.current.clientHeight);
        }
    }, []);
    var percentage = parseFloat((dataset.total / total || 0) * 100).toFixed(2);
    var barPercentage = parseFloat((dataset.total / highestTotal || 0) * 100).toFixed(2);
    var thumbImage = dataset.image && dataset.image.thumbnail;
    if (isCrossTab) {
        var barPercentage1 = mode === 'percentage' ? 100 : parseFloat((dataset.total / highestTotal || 0) * 100).toFixed(2);
        return /*#__PURE__*/ React.createElement(S.Row, null, /*#__PURE__*/ React.createElement(S.RowLabel, {
            withThumbImage: thumbImage
        }, dataset.label), /*#__PURE__*/ React.createElement(S.RowBar, null, /*#__PURE__*/ React.createElement(S.Bar, null, /*#__PURE__*/ React.createElement(S.CrossTabRow, {
            percentage: barPercentage1
        }, dataset.values.map(function(value, idx) {
            var percentage = parseFloat((value.total / dataset.total || 0) * 100).toFixed(2);
            if (!percentage || percentage <= 0 || !legends[value.label]) {
                return null;
            }
            var bg = S.getBarLabelColor(idx);
            return /*#__PURE__*/ React.createElement(S.BarItem, {
                key: value.id,
                background: bg,
                percentage: percentage,
                "data-for": toolTipId,
                "data-tip": rowIndex
            }, /*#__PURE__*/ React.createElement(S.BarItemLabel, {
                color: bg,
                style: {
                    visibility: 'initial'
                }
            }, mode === 'percentage' ? "".concat(percentage, "%") : value.total));
        })))));
    }
    var showAccordion = dataset.option_type === asset.constants.TAP_OPTION_TYPE_PINNED_WITH_TEXT && dataset.other_answers;
    var renderOtherAnswers = function() {
        return showAccordion && /*#__PURE__*/ React.createElement(Flex, {
            align: "flex-start",
            mb: "15px"
        }, /*#__PURE__*/ React.createElement(C.img, {
            src: asset.arrow_right_icon,
            p: "10px"
        }), /*#__PURE__*/ React.createElement(Accordion, {
            flexGrow: "1"
        }, /*#__PURE__*/ React.createElement(AccordionItem, {
            itemTitle: "View Text Answers",
            _buttonStyle: {
                bg: 'gray.100',
                borderRadius: 'base'
            }
        }, /*#__PURE__*/ React.createElement(S.TableContainer, null, /*#__PURE__*/ React.createElement(Table, null, /*#__PURE__*/ React.createElement(Tbody, null, dataset.other_answers.map(function(value, i) {
            return /*#__PURE__*/ React.createElement(Tr, {
                key: i
            }, /*#__PURE__*/ React.createElement(Td, null, i + 1, ") ", value));
        })))))));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(S.Row, {
        grayBg: true
    }, thumbImage && /*#__PURE__*/ React.createElement(S.RowThumbImage, {
        onClick: onViewFullImage,
        src: thumbImage
    }), /*#__PURE__*/ React.createElement(S.RowBar, {
        grayBg: true
    }, /*#__PURE__*/ React.createElement(S.Bar, null, /*#__PURE__*/ React.createElement(S.BarItem, {
        percentage: percentage
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            height: height
        }
    }))), /*#__PURE__*/ React.createElement(S.BarLabel, null, /*#__PURE__*/ React.createElement(S.BarLabelContent, {
        ref: labelRef
    }, dataset.label), /*#__PURE__*/ React.createElement(S.BarRowLabel, null, "".concat(dataset.total, " (").concat(percentage, "%)"))))), renderOtherAnswers());
});
